import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { AuthenticationService } from "../authentication/authentication.service";
import { NavigationService } from "../navigation/navigation.service";

@Injectable()
export class AdminGuard implements CanActivate {
	constructor(private authService: AuthenticationService, private navigationService: NavigationService) { }

	public canActivate() {
		const currentUser = this.authService.getCurrentUser();
		if (!currentUser || !currentUser.admin) {
			this.navigationService.navigate(["/userresourcelist"]);
			return false;
		}

		return true;
	}
}
